import { BaseEnum } from "./baseEnum";

const shirtSizeEnum: Array<ShirtSizeEnum> = [];

export class ShirtSizeEnum extends BaseEnum {
  static P = new ShirtSizeEnum(0, "P", "P", "P", "Pequeno");
  static M = new ShirtSizeEnum(1, "M", "M", "M", "Médio");
  static G = new ShirtSizeEnum(2, "G", "G", "G", "Grande");
  static GG = new ShirtSizeEnum(3, "GG", "GG", "GG", "Extra Grande");
  static XGG = new ShirtSizeEnum(4, "XGG", "XGG", "EGG1", "Extra Extra Grande");
  static XXG = new ShirtSizeEnum(5, "XXG", "XXG", "EGG2", "Extra Extra Extra Grande");

  constructor(
    public id: number,
    public value: string,
    public en: string,
    public pt: string,
    public description: string
  ) {
    super(id, en, pt);
    shirtSizeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return shirtSizeEnum;
  }

  toOption() {
    return { value: this.value, label: this.label };
  }

  toDetailedOption() {
    return {
      id: this.id,
      value: this.value,
      label: this.en,
      description:
        this.en === this.pt
          ? this.description
          : `${this.description}/${this.pt}`,
    };
  }
}
